import { useState } from "react";

import { useRerender } from "~/hooks/useRerender";
import { useBreakpoints } from "~/hooks/useBreakpoints";

import { QuizViewManager } from "./QuizViewManager";

import type { QuizViewManagerInit } from "./QuizViewManager";

export interface QuizView extends QuizViewManager {
  isDesktopLayout: boolean;
}

/**
 * Used as a state manager for quizzes. QuizView components
 * provide the layout and structure; this hook provides the
 * state.
 */
export function useQuizView(init: QuizViewManagerInit): QuizView {
  const rerender = useRerender();
  const breakpoints = useBreakpoints();

  const [managerRef] = useState(() => ({
    current: new QuizViewManager({
      ...init,
      onUpdate() {
        // Call the consumer's handler
        init.onUpdate?.();

        // Trigger a re-render
        rerender();
      },
    }),
  }));

  return Object.assign(managerRef.current, {
    isDesktopLayout: breakpoints.lg,
  });
}
